/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IMediaCategoryModel } from "@nf/common";
import { RouteHelper } from "helpers/routeHelper";

import GenreCard from "./GenreCard";
import LinkWithLocale from "components/LinkWithLocale";

import styles from "./Genres.module.scss";

interface GenresProps {
  genres: IMediaCategoryModel[];
}

const Genres = ({ genres }: GenresProps) => (
  <ul className={styles.genres}>
    {genres.map((genre) => (
      <li key={genre.CategoryId} className={styles.genre}>
        <LinkWithLocale href={RouteHelper.goToGenre(genre.CategoryId)}>
          <a>
            <GenreCard id={genre.CategoryId} name={genre.CategoryName} />
          </a>
        </LinkWithLocale>
      </li>
    ))}
  </ul>
);

export default Genres;
